import { api } from "./api";
import type {
  ClearanceType,
  CompleteDepartureRequestArgs,
  DepartureResponse,
  RequestDeparture,
} from "./departure/types";

const SERVICE = "bff-vessel-call";

export const createDepartureRequest = async (payload: RequestDeparture, transactionId?: string) => {
  return api.post<RequestDeparture>(
    SERVICE,
    "departures",
    payload,
    ...(transactionId ? [{ transactionId }] : []),
  );
};

export const resubmitDepartureRequest = async (
  payload: DepartureResponse,
  id: string,
  transactionId?: string,
) => {
  return api.put<DepartureResponse>(
    SERVICE,
    `departures/${id}`,
    payload,
    ...(transactionId ? [{ transactionId }] : []),
  );
};

export const getDepartureCallById = async (id: string) => {
  return api.get<DepartureResponse>(SERVICE, `departures/${id}`);
};

export const getDepartureTaskById = async (id: string) => {
  return api.get<DepartureResponse>(SERVICE, `departures/tasks/${id}`);
};

export const claimDepartureRequest = async (taskId: string, transactionId?: string) => {
  return api.put(
    SERVICE,
    `departures/tasks/${taskId}:claim`,
    ...(transactionId ? [undefined, { transactionId }] : []),
  );
};

export const unclaimDepartureRequest = async (taskId: string, transactionId?: string) => {
  return api.put(
    SERVICE,
    `departures/tasks/${taskId}:unclaim`,
    ...(transactionId ? [undefined, { transactionId }] : []),
  );
};

export const completeDepartureTask = async ({
  taskId,
  params,
  transactionId,
}: {
  taskId: string;
  params: CompleteDepartureRequestArgs;
  transactionId?: string;
}) => {
  return api.put(
    SERVICE,
    `departures/tasks/${taskId}:complete`,
    { ...params },
    ...(transactionId ? [{ transactionId }] : []),
  );
};

export const getClearanceType = async (vesselCallId: string): Promise<ClearanceType> => {
  return api.get(SERVICE, `/departures/${vesselCallId}/requested-clearance-type`);
};
